<template>
    <div v-if="Object.keys(model).length !== 0" class="wrapper">
        <item-form
            :model="model"
            :modellichtintegratie="modellichtintegratie"
            :invloedspercentages="invloedspercentages"
            :modelvoorstel="modelvoorstel"
            :modelklassiekeuren="modelklassiekeuren"
            :isEditing="true"
            @save-item="updateItem"
            @create-schema="createSchema"
            @save-refresh="saveRefresh">
        </item-form>

        <b-modal title="Wijzigen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Data werden niet aangepast! {{errormsg}}
        </b-modal>

        <b-modal title="Formulier creëren" size="sm" class="modal-primary" v-model="warningGeduld">
            <div slot="modal-footer" class="w-100"><p>Even geduld a.u.b.</p></div>
            <p><fadeloader :loading="loading" :size="size" :color="color" class="spinner"></fadeloader></p>
            <p>&nbsp;<br/>&nbsp;</p>
            <p>Formulier wordt gecreëerd. Deze bewerking kan even duren.</p>
        </b-modal>

        <b-modal title="Formulier creëren" size="sm" class="modal-danger" v-model="warningSchema" @ok="closedialog">
            FOUT: Formulier werd niet gecreëerd! {{errormsg}}
        </b-modal>
    </div>
    <div v-else class="midden">
        <div style="color: #20a8d8; font-size: large;">Even geduld a.u.b.</div>
        <fadeloader :loading="loading" :size="size" :color="color" class="spinner2"></fadeloader>
    </div>
</template>

<script>
    // https://github.com/greyby/vue-spinner
    import FadeLoader from 'vue-spinner/src/FadeLoader';
    import api from '../../api/afdelingteelt';
    import ItemForm from './FormWerkelijk';

    export default {
        data () {
            return {
                warningModal: false,
                warningSchema: false,
                warningGeduld: false,

                errormsg: '',
                model: { },
                modellichtintegratie: { },
                modelvoorstel: { },
                modelklassiekeuren: { },
                invloedspercentages: { },

                loading: true,
                size: '20px',
                color: '#20a8d8',
            };
        },
        created () {
            this.getSchema(this.$route.params.id);
            this.getVoorstel(this.$route.params.id);
            this.getKlassiekeUren(this.$route.params.id);
        },
        methods: {
            getSchema (id) {
                api.getWerkelijkebelichting(id).then((response) => {
                    this.model = response.data.werkelijk.model;
                    this.modellichtintegratie = response.data.lichtintegratie.model;
                    this.invloedspercentages = response.data.lichtintegratie.invloedspercentages;
                });
            },
            getVoorstel (id) {
                api.getVoorstelBelichting(id).then((response) => {
                    this.modelvoorstel = response.data.model;
                });
            },
            getKlassiekeUren (id) {
                api.getKlassiekebelichting(id).then((response) => {
                    this.modelklassiekeuren = response.data.model;
                });
            },
            saveRefresh (id, model) {
                api.updateWerkelijkebelichting(model).then(() => {
                    api.getVoorstelBelichting(id).then((response) => {
                        this.modelvoorstel = response.data.model;
                    });
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            createSchema (model) {
                this.warningGeduld = true;
                api.createWerkelijkebelichting(model).then(() => {
                    this.warningGeduld = false;
                    this.getSchema(model.id);
                    this.getVoorstel(model.id);
                    this.getKlassiekeUren(model.id);
                },
                (error) => {
                    this.warningGeduld = false;
                    this.errormsg = error.message;
                    this.warningSchema = true;
                });
            },
            updateItem (model) {
                api.updateWerkelijkebelichting(model).then(() => {
                    this.$router.replace('/beheer/afdelingteelt');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
                this.warningSchema = false;
            },
        },
        components: {
            'item-form': ItemForm,
            fadeloader: FadeLoader,
        },
    };
</script>

<style>

    .spinner {
        margin-top: 30px;
        margin-bottom: 20px;
        margin-left:130px;
        color: #20a8d8;
    }

    .spinner2 {
        margin-top: 30px;
        margin-left:75px;
        color: #20a8d8;
    }

    .midden {
        width: 150px;
        height: 100px;

        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        margin: auto;
    }

</style>



// WEBPACK FOOTER //
// src/pages/licht/EditWerkelijk.vue